import {
  PaymentLineItemEnum,
  type PaymentBreakdown,
} from "@b2bportal/air-booking-api";
import type { PaymentBreakdown as LodgingPaymentBreakdown } from "@b2bportal/lodging-api";

export type AnyPaymentBreakdown = PaymentBreakdown | LodgingPaymentBreakdown;

/**
 * Whether a booking was settled with the Nubank credit line.
 *
 * Flights and hotels expose different payment-breakdown types
 * (`@b2bportal/air-booking-api` vs `@b2bportal/lodging-api`) but share the same
 * `NupayCredit` line-item discriminator, so we normalize to a structural type
 * and look for it in either product's payload. Used to gate the enhanced-earn
 * (points cashback) row in the My Trips price breakdown.
 */
export const isNubankCreditPayment = (
  paymentBreakdown?: AnyPaymentBreakdown
): boolean => {
  // Read the real `payments` property from each typed breakdown so a field
  // rename in either API breaks compilation instead of silently returning
  // false. Air and lodging line items are distinct enum types, so widen to
  // the shared `PaymentLineItem` discriminator (assignability-checked, not a
  // blind cast) before comparing against NupayCredit across both products.
  const payments: ReadonlyArray<{ PaymentLineItem: string }> =
    paymentBreakdown?.payments ?? [];
  return payments.some(
    (payment) => payment.PaymentLineItem === PaymentLineItemEnum.NupayCredit
  );
};
